import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/App';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Lock, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error('Les mots de passe ne correspondent pas');
      return;
    }
    if (password.length < 6) {
      toast.error('Le mot de passe doit contenir au moins 6 caracteres');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      setDone(true);
      toast.success('Mot de passe mis a jour');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Lien invalide ou expire');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-[#f1f5f9] flex items-center justify-center px-4">
        <div className="text-center space-y-4">
          <p className="text-muted-foreground">Lien invalide</p>
          <Link to="/login" className="text-sm text-primary hover:underline">Retour a la connexion</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f1f5f9] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-[#1A4D2E] tracking-wider">SSCaraïbes.com</h1>
        </div>

        <div className="bg-white rounded-xl border border-border/50 shadow-sm p-6">
          {done ? (
            <div className="text-center space-y-4">
              <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mx-auto">
                <CheckCircle2 className="h-6 w-6 text-emerald-600" />
              </div>
              <h2 className="font-heading font-semibold text-lg">Mot de passe modifie</h2>
              <p className="text-sm text-muted-foreground">Vous pouvez maintenant vous connecter.</p>
              <Link to="/login">
                <Button className="rounded-full" data-testid="back-to-login-btn">Se connecter</Button>
              </Link>
            </div>
          ) : (
            <>
              <div className="flex items-center gap-2 mb-5">
                <Lock className="h-5 w-5 text-primary" />
                <h2 className="font-heading font-semibold text-lg">Nouveau mot de passe</h2>
              </div>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Label>Nouveau mot de passe</Label>
                  <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="6 caracteres minimum" required data-testid="new-password-input" />
                </div>
                <div>
                  <Label>Confirmer</Label>
                  <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirmez le mot de passe" required data-testid="confirm-password-input" />
                </div>
                <Button type="submit" className="w-full rounded-full" disabled={loading} data-testid="reset-submit-btn">
                  {loading ? 'Mise a jour...' : 'Mettre a jour le mot de passe'}
                </Button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
